/* eslint-disable import/no-relative-packages */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import {
  View,
  Text,
  Image,
  TouchableOpacity,
  Linking,
  Platform,
  Modal,
  Clipboard,
} from 'react-native';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import {
  Rating,
  Icon,
  Input,
} from 'react-native-elements';
// import Rating from 'react-native-rating';
import QRCode from 'react-native-qrcode-svg';

// import { sprintf } from '../../../vendor/sprintf-js/src/sprintf';
import { translate, translateTime } from '../../locales/i18n';
import AORTypes from '../../types';
import styles from '../../styles';
import { locale } from '../../localization';

import camera from '../../assets/images/glyphicons-camera.png';
// import camera from './images/glyphicons-camera.png';
// import starGrey from '../../assets/images/star-grey.png';
// import starYellow from '../../assets/images/star-yellow.png';
// import money from '../../assets/images/glyphicons-money.png';
import starStandard from '../../../node_modules/react-native-ratings/src/images/star.png'; // FIXME(clairbee): fix webpack config instead
// import starStandard from '../../assets/images/star.svg';

import infraConfig from '../../config.json';

import logo from '../../assets/icons/favicon.png';
import imageClose from '../../assets/images/glyphicons-remove-sign.png';

// const imgStarGrey = <img alt="" src={starGrey} />;
// const imgStarYellow = <img alt="" src={starYellow} />;

const openURL = (url) => {
  if (Platform.OS === 'web') {
    window.open(url, '_blank');
  } else {
    Linking.openURL(url);
  }
};

class AppBadge extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showPopupShare: false,
      showPopupQr: false,
      qrData: '',
    };
  }

  componentDidMount() {
    const {
      icons,
    } = this.props;

    if (icons) {
      this.getDataURL(); // => Calling this in here to make sure the QRCode component did mount
    }
  }

  getDataURL() {
    if (this.svg !== undefined && this.svg.toDataURL !== undefined) {
      console.log(this.svg);
      this.svg.toDataURL(this.callback);
    }
  }

  callback(dataURL) {
    this.setState({ qrData: dataURL });
  }

  render() {
    const {
      data,
      style,
      nopromo,
      selected,
      reviewsClickable,
      history,
      icons,
      // embedded,
      // notags,
    } = this.props;
    const {
      showPopupShare,
      showPopupQr,
      qrData,
    } = this.state;

    if (!data) {
      return (
        <Text>
          Error loading the app.
        </Text>
      );
    }

    // console.log(props);
    let image = camera;
    const hasImage = data.image && data.image !== '' && data.image.substring !== undefined;
    if (hasImage) {
      const prefix = data.image.substring(6, 8)
        + data.image.substring(4, 6)
        + data.image.substring(2, 4)
        + data.image.substring(0, 2);
      // const prefix = data.uuid.substring(0, 8);
      // console.log(prefix);
      let index = parseInt(prefix, 16) % 100;
      index += 100;
      index = index.toString().substr(-2, 2);
      // console.log(index);
      image = { uri: `https://${infraConfig.imagesThumbs128Bucket}.s3-${infraConfig.region}.amazonaws.com/${index}/${data.image}` };
    }

    const promoted = data.promoted && !nopromo;

    // const duration = data.duration || 0;
    // const hours = Math.floor(duration / 3600);
    // const minutes = Math.floor((duration - hours * 3600) / 60);
    // const seconds = duration % 60;

    // let durationText = sprintf('%d:%02d', minutes, seconds);
    // if (hours > 0) {
    //   durationText = sprintf('%d:%02d:%02d', hours, minutes, seconds);
    // }

    const durationText = data.duration ? translateTime(data.duration) : undefined;

    // TODO(clairbee): convert to the viewer's currency
    const currencyFormatter = data.currency ? new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: data.currency,
      currencyDisplay: 'symbol',
      // currencyDisplay: 'narrowSymbol',
    }) : { format: (a) => a };

    const styleComplemented = {
      ...style,
    };
    // if (styleComplemented.minWidth === undefined) {
    //   styleComplemented.minWidth = 310;
    // }
    // if (styleComplemented.maxWidth === undefined) {
    //   styleComplemented.maxWidth = 500;
    // }

    return (
      <View
        key={data.uuid}
        style={styleComplemented}
      // {...(embedded ? {} : { // eslint-disable-line react/jsx-props-no-spreading
      //   itemScope: true,
      //   itemType: 'http://schema.org/ConsumerDestination',
      // })}
      >
        {Platform.OS === 'web' && (
          <>
            {/* SEO tags */}
            {/* <meta key="url" itemProp="url" content={`https://${infraConfig.domainName}/ai-agent/online/${data.uuid}`} />
            <View key="geo" itemProp="geo" itemType="https://schema.org/GeoCoordinates" itemScope>
              <meta key="latitude" itemProp="latitude" content={data.lat} />
              <meta key="longitude" itemProp="longitude" content={data.lon} />
            </View>
            <link
              key="image"
              itemProp="image"
              href={image.uri}
            />
            {data.type === 0 ? (
              <meta key="isAccessibleForFree" itemProp="isAccessibleForFree" content="true" />
            ) : (
              <meta key="appBookingPage" itemProp="appBookingPage" content={`https://${infraConfig.domainName}/purchase/${data.uuid}`} />
            )}
            <meta key="publicAccess" itemProp="publicAccess" content="true" />
            {data.travelType === 2 && (
              <meta key="hasDriveThroughService" itemProp="hasDriveThroughService" content="true" />
            )}
            <View key="additionalProperty" itemProp="additionalProperty" itemScope itemType="https://schema.org/PropertyValue">
              <meta key="name" itemProp="name" content="Publisher" />
              <meta key="value" itemProp="value" content={data.guideName} />
            </View>
            <View key="additionalProperty2" itemProp="additionalProperty" itemScope itemType="https://schema.org/PropertyValue">
              <meta key="name" itemProp="name" content="Publisher Description" />
              <meta key="value" itemProp="value" content={data.guideDesc} />
            </View> */}
          </>
        )}

        {/* The real (non-SEO) tags */}
        <View
          key="badge"
          style={[
            promoted ? styles.appBadge.panelPromoted : styles.appBadge.panel,
            selected && {
              backgroundColor: 'white',
              shadowColor: 'teal',
              shadowRadius: 10,
              shadowOffset: { width: 0, height: 0 },
              shadowOpacity: 1,
            },
          ]}
        >
          <View key="inner" style={styles.appBadge.panelInner}>
            <Text
              key="name"
              itemProp="name"
              style={promoted ? styles.appBadge.namePromoted : styles.appBadge.name}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {data.name}
            </Text>
            <Text
              key="description"
              itemProp="description"
              style={promoted ? styles.appBadge.descriptionPromoted : styles.appBadge.description}
              numberOfLines={3}
              ellipsizeMode="tail"
            >
              {data.desc}
            </Text>
            {/* <Rating style={styles.appBadge.rating} /> */}
            <View key="panelRating" style={styles.appBadge.panelRating}>
              <Rating
                key="rating"
                type="custom"
                ratingImage={starStandard}
                imageSize={17}
                ratingColor="#FE9065"
                // ratingBackgroundColor="#F2554C"
                readonly
                startingValue={data.rating || 0}
                style={styles.appBadge.rating}
              />
              {(reviewsClickable && data.reviews) ? (
                // <TouchableOpacity
                //   key="reviews"
                //   onPress={() => (
                //     history.push(`/reviews/${data.uuid}`)
                //   )}
                // >
                <Text style={styles.appBadge.reviews} textDecorationLine="underline">{data.reviews ? data.reviews : ''}</Text>
                // </TouchableOpacity>
              ) : (
                <Text key="reviews" style={styles.appBadge.reviews} textDecorationLine="underline">{data.reviews ? data.reviews : ''}</Text>
              )}
            </View>
            <View key="panelBottom" style={styles.appBadge.panelBottom}>
              {data.duration && (
                <Text key="duration" style={styles.appBadge.duration} numberOfLines={1}>{durationText}</Text>
              )}
              {data.type ? (
                <>
                  {/* <Image key="priceImage" style={styles.appBadge.priceImage} source={money} /> */}
                  <Text key="price" style={styles.appBadge.price} numberOfLines={1}>
                    {
                      data.type < 4 ? '--' : (
                        <div style={{ display: 'inline' }} title={`${currencyFormatter.format(data.queryPrice)} ${data.currency} per query`}>
                          {currencyFormatter.format(data.queryPrice)}
                        </div>
                      )
                    }
                    {' / '}
                    {/* post processed pre-currency */}
                    {
                      data.type % 2 === 0 ? '--' : (
                        <div style={{ display: 'inline' }} title={`${currencyFormatter.format(data.rentPrice)} ${data.currency} for ${data.rentDays} days of limited access`}>
                          {currencyFormatter.format(data.rentPrice)}
                        </div>
                      )
                    }
                    {' / '}
                    {
                      (data.type % 4) < 2 ? '--' : (
                        <div style={{ display: 'inline' }} title={`${currencyFormatter.format(data.buyPrice)} ${data.currency} for permanent access`}>
                          {currencyFormatter.format(data.buyPrice)}
                        </div>
                      )
                    }
                    {/* post processed post-currency */}
                  </Text>
                </>
              ) : (
                <Text key="price" style={{ ...styles.appBadge.price, marginLeft: 0 }} numberOfLines={1} ellipsizeMode="tail">
                  {translate('app_free')}
                </Text>
              )}
              {/* {!notags && (
                <>
                  {data.tag1 && (
                    <TouchableOpacity
                      accessibilityLabel={data.tag1}
                      accessibilityRole="link"
                      // TODO: Keep href for the statically rendered pages only
                      href={Platform.OS === 'web' ? `/ai-agents/${data.tag1}` : undefined}
                      style={{
                        padding: 0,
                        margin: 0,
                      }}
                      // key={tag}
                      onPress={() => {
                        history.push(`/ai-agents/${data.tag1}`);
                      }}
                    >
                      <Text style={styles.appBadge.tag} numberOfLines={1} ellipsizeMode="tail">
                        {data.tag1}
                      </Text>
                    </TouchableOpacity>
                  )}
                  {data.tag2 && (
                    <TouchableOpacity
                      accessibilityLabel={data.tag2}
                      accessibilityRole="link"
                      // TODO: Keep href for the statically rendered pages only
                      href={Platform.OS === 'web' ? `/ai-agents/${data.tag2}` : undefined}
                      style={{
                        padding: 0,
                        margin: 0,
                      }}
                      onPress={() => {
                        history.push(`/ai-agents/${data.tag2}`);
                      }}
                    >
                      <Text style={styles.appBadge.tag} numberOfLines={1} ellipsizeMode="tail">
                        {data.tag2}
                      </Text>
                    </TouchableOpacity>
                  )}
                </>
              )} */}
            </View>
          </View>
          <View key="image" style={styles.appBadge.imageBlockBackground}>
            <Image
              itemProp="image"
              style={hasImage ? styles.appBadge.imageBlock : styles.appBadge.imageBlockNone}
              source={image}
            />
          </View>
        </View>
        {icons && /* show tags only if there are icons shown too */ (
          <View
            key={`tags-${data.uuid}`}
            style={{
              marginVertical: 10,
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            {[data.tag1, data.tag2, data.tag3, data.tag4, data.tag5].map((tag) => (tag && (
              <TouchableOpacity
                key={`tag-${tag}-${data.uuid}`}
                accessibilityLabel={tag}
                accessibilityRole="link"
                // TODO: Keep href for the statically rendered pages only
                href={Platform.OS === 'web' ? `/ai-agents/${tag}` : undefined}
                style={{
                  padding: 0,
                  margin: 0,
                }}
                // key={tag}
                onPress={() => {
                  history.push(`/ai-agents/${tag}`);
                }}
              >
                <Text style={styles.appBadge.tag} numberOfLines={1} ellipsizeMode="tail">
                  {tag}
                </Text>
              </TouchableOpacity>
            )))}
          </View>
        )}
        {icons && (data.linkWeb || data.linkYoutube || data.linkFacebook || data.linkInstagram || data.linkTwitter) && (
          <View
            key={`icons-${data.uuid}`}
            style={{
              marginTop: 10,
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            {[
              [data.linkWeb && data.linkWeb !== '', 'globe', () => openURL(data.linkWeb)],
              [data.linkYoutube && data.linkYoutube, 'youtube', () => openURL(data.linkYoutube)],
              [data.linkFacebook && data.linkFacebook !== '', 'facebook', () => openURL(data.linkFacebook)],
              [data.linkInstagram && data.linkInstagram !== '', 'instagram', () => openURL(data.linkInstagram)],
              [data.linkTwitter && data.linkTwitter !== '', 'twitter', () => openURL(data.linkTwitter)],
              [true, 'share-alt', () => this.setState({ showPopupShare: true })],
              [true, 'qrcode', () => this.setState({ showPopupQr: true })],
            ].map((item) => (item[0] ? (
              <Icon
                containerStyle={{
                  marginTop: 4,
                  marginBottom: 8,
                  marginHorizontal: 6,
                }}
                key={item[1]}
                name={item[1]}
                type="font-awesome"
                size={32}
                color={styles.primaryColorMildOpacity}
                onPress={item[2]}
              />
            ) : undefined))}
          </View>
        )}
        {showPopupShare && (
          <Modal
            key="modalShare"
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              borderWidth: 0,
            }}
            transparent
            presentationStyle="overFullScreen"
            visible
          >
            <View
              style={{
                flex: 1,
                position: 'relative',
                alignSelf: 'center',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  position: 'relative',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  padding: 24,
                  paddingRight: 56,
                  paddingBottom: 12,
                  borderColor: styles.primaryColor,
                  borderWidth: 8,
                }}
              >
                <Input
                  key="url"
                  containerStyle={{
                    flex: 1,
                  }}
                  disabled={false}
                  value={`https://${infraConfig.domainName}/ai-agent/${data.uuid}`}
                  selection={{
                    start: 0,
                    end: 0,
                  }}
                  selectTextOnFocus
                />
                <Icon
                  key="copy"
                  style={{
                    margin: 10,
                    width: 48,
                  }}
                  name="copy"
                  type="font-awesome"
                  size={32}
                  color="gray"
                  onPress={() => Clipboard.setString(`https://${infraConfig.domainName}/ai-agent/${data.uuid}`)}
                />

                <TouchableOpacity
                  key="close"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    margin: 5,
                    width: 32,
                    height: 32,
                    borderRadius: 32,
                  }}
                  onPress={() => {
                    this.setState({ showPopupShare: false });
                  }}
                >
                  <Image
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 32,
                      backgroundColor: 'white',
                    }}
                    source={imageClose}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </Modal>
        )}
        {showPopupQr && (
          <Modal
            key="modalQr"
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              borderWidth: 0,
            }}
            transparent
            presentationStyle="overFullScreen"
            visible
          >
            <View
              style={{
                flex: 1,
                position: 'relative',
                alignSelf: 'center',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  position: 'relative',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  padding: 24,
                  paddingRight: 56,
                  paddingBottom: 12,
                  borderColor: styles.primaryColor,
                  borderWidth: 8,
                }}
              >
                <QRCode
                  key="qr"
                  size={128}
                  value={`https://aionrails.com/ai-agent/${data.uuid}`}
                  logo={logo}
                  logoSize={32}
                  getRef={(c) => { this.svg = c; }}
                  onPress={() => {
                    if (qrData.length !== 0) {
                      Print.printAsync({ // eslint-disable-line no-undef
                        html: `
                           <h3>Quick access to this AI agent:</h3>
                           <img src="${qrData}"/>
                           <img src="data:image/png;base64,${qrData}"/>
                         `,
                      });
                    }
                  }}
                />

                <TouchableOpacity
                  key="close"
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    margin: 5,
                    width: 32,
                    height: 32,
                    borderRadius: 32,
                  }}
                  onPress={() => {
                    this.setState({ showPopupQr: false });
                  }}
                >
                  <Image
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 32,
                      backgroundColor: 'white',
                    }}
                    source={imageClose}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </Modal>
        )}
      </View>
    );
  }
}

AppBadge.defaultProps = {
  embedded: false,
  icons: false,
  nopromo: false,
  notags: false,
  selected: false,
  reviewsClickable: false,
  style: {},
  history: undefined,
};

AppBadge.propTypes = {
  embedded: PropTypes.bool, // Not a top level app element. For SEO tags.
  icons: PropTypes.bool,
  nopromo: PropTypes.bool,
  notags: PropTypes.bool,
  selected: PropTypes.bool,
  reviewsClickable: PropTypes.bool,
  data: AORTypes.App.isRequired,
  style: ViewPropTypes.style,
  history: ReactRouterPropTypes.history,
};

export default AppBadge;
